module.exports = __webpack_public_path__ + "static/00-458e3fd4dea93eaa7418104d59ea7471.jpg";